import { render, staticRenderFns } from "./LanguageFilter.vue?vue&type=template&id=0b3b79b0"
import script from "./LanguageFilter.vue?vue&type=script&lang=ts"
export * from "./LanguageFilter.vue?vue&type=script&lang=ts"
import style0 from "./LanguageFilter.vue?vue&type=style&index=0&id=0b3b79b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports